import { Address } from './Address'
import { Appraisal } from './Appraisal'
import { DemandRegion } from './DemandRegion'
import { DemandServiceType } from './DemandServiceType'
import { Problems } from './Problems'

export class Demand {
	public _id: string
	public identification: number
	public requester: string
	public process: string
	public email_requester: string
	public cpf_requester: string
	public tel_requester: string
	public created_date: Date
	public scheduling_date: Date
	public media_url: string
	public address: Address
	public archive: string
	public observation: string
	public company: string
	public company_id: string
	public appraisal: Appraisal
	public problem: Array<Problems>
	public problems: Array<Problems>
	public reference?: string
	public mediaUrl: Array<string>
	public problemsQuestions: any
	public done?: boolean
	public treeIdentifier?: string
	public serviceType: DemandServiceType
	public region: DemandRegion
	public checked?: boolean
}

export class DemandSelect {
	public idMongo: string
	public treeId?: string
	public identification: number
	public problems?: Array<string> = []
	public treeIdentification?: number
	public media: Array<string> = []
	public mediaSelected: string = ''
	public markerIndex?: number
}

export class ListDemandSchedule {
	public idMongo: string
	public address: string
	public process: string
	public lat: number
	public lng: number
	public treeId: number
	public tree_id: string
	public identifier: string
	public protocol: number
	public requester: string
	public emailRequester: string
	public mediaUrl: Array<string>
	public serviceType: string
	public createDate: string
	public region: string
	public osa: number
	public schedule: string
	public evaluator: string
	public status: string
	public media: Array<string> = []
	public problems: Array<string> = []
	public markerIndex?: number
}

export class DemandDetails {
	public idMongo: string = ''
	public companyId: string = ''
	public protocol: number = 0
	public osa: number
	public cnpjRequester: string
	public socialNameRequester: string
	public treeIdentification: number = 0
	public requester: string = ''
	public emailRequester: string = ''
	public cpfRequester: string = ''
	public telephoneRequester: string = ''
	public requesterNotEditable: boolean = false
	public identifier: string = ''
	public process: string = ''
	public treeIdentifier: string = ''
	public address: string = ''
	public lat: number = 0
	public lng: number = 0
	public reference: string = ''
	public serviceType: DemandServiceType = new DemandServiceType()
	public region: DemandRegion = new DemandRegion()
	public media: Array<string> = []
	public problems: Array<{
	  _id: string,
	  name: string,
	  media_url: string,
	  active: boolean
	}> = []
	public appraisalId: string = ''
	public evaluator: string = ''
	public schedule: string = ''
	public status: string = ''
	public oldDemand: string = ''
	public parentDemand: {
		idMongo: string;
		protocol: number;
		address: string;
		status: string;
	}
	public childs: Array<{
		protocol: number
	}> = []
}

export class DemandDetailsSchedule {
	public reference: string
	public media: Array<string> = []
	public problems: Array<string> = []
}

export class ListDemandHistory {
	public idMongo: string
	public process: string
	public osa: number
	public operation: Array<string>
	public street: string
	public region: string
	public evaluator: string
	public evaluatorIdMongo: string
	public done: boolean
	public treeNotFound: boolean
	public enableCommunication: boolean
	public comunicationNumber: string
	public date: string
	public demandStatus: 'WITHOUT_DEMAND' | 'WITH_DEMAND' | 'ADDED_DEMAND'
	public Demands: Array<{
		process: string;
		protocol: number;
		requester: string;
		cpfRequester: string;
		emailRequester: string;
		done: boolean;
		idMongo: string;
	}>
	public EvaluationResult: {
	  N3: boolean,
	  degreeRisk: string
	}
	public Tree: {
	  identification: number,
	  identifier: string
	}
	public Report: {
	  date: Date,
	  responsible: string,
	  file: Array<{
		file: string,
		category: {
		  _id: string,
		  name: string
		}
	  }>,
	  risk: string
	}
	public showDetails: boolean
	public status: string
}

export class ZooMaps {
	public trees: Array<TreeMapDTO> = []
	public appraisals: Array<AppraisalMapDTO> = []
}

class AppraisalMapDTO {
	public _id: string
	public address: {
		street: string;
		lat: number;
		lng: number;
	}
	public tree: {
		_id: string;
		media_url: Array<string>;
		identifier?: string;
	}
	public demands?: Array<string>
	public evaluator: {
		_id: string;
		name: string;
	}
	public company: string
	public schedulingDate: string
}

class TreeMapDTO {
	public tree: {
		media_url?: Array<string>;
		media_url_inventory?: Array<string>;
		tree_not_found: boolean;
		observation: string;
		_id: string;
		identification: number;
		identificationOffline: string;
		treeInventaried: boolean;
		category_tree: number;
		location: {
			type: string;
			coordinates: Array<number>;
		};
		user_creator: string;
		company: string;
		status: string;
		address: string;
		create_date: string;
		identifier: string;
		historic_appraisal: Array<string>;
		historic_inventory: Array<string>;
		species: {
			nomenclature: {
			popularName: string;
			scientificName: string;
			synonymy: string;
			botanicalClassification: string;
			};
			characterization: any;
			evaluationComponents: any;
			additionalInformation: {
			bibliographicSource: string;
			recognitionTips: string;
			};
			gallery: Array<string>;
			botanicalKeys: Array<string>;
			_id: string;
			status: string;
		}
	}
}

export class ManyDemandForNotify {
	public demandsSelected: Array<{
		idMongo: string,
		cpfRequester: string
	}> = []
	public idMongoDemandsSelected: Array<string> = []
	public requesterSelected: Array<RequesterSelected> = []
	public countDemandsWithoutRequester: number = 0
}

export class RequesterSelected {
	public nameRequest: string = ''
	public emailRequest: string = ''
	public cpfRequester: string = ''
	public numberAppraisals: number = 0
}

export class NotifyRequester {
	public appraisalsIds: Array<string>
	public demandIds?: Array<string>
	public html: string
}

export class DemandAttach {
	public idMongo: string
	public protocol: number
	public process: string
	public treeId: number
	public identifier: string
	public requester: string
	public cpfRequester: string
	public address: string
	public date: string
}

export class RequestNearDemands {
	public lat: number
	public lng: number
	public companyId: string
	public selfDemandId?: string
}

export class DemandNear {
	public idMongo: string
	public lat: number
	public lng: number
	public type: 'notScheduled' | 'scheduled'
}

export class DetailDemandNear {
	public idMongo: string
	public protocol: number
	public process: string
	public media: Array<string>
	public schedule: string
	public status: string
	public osa: number
	public requester: string
	public cpfRequester: string
	public evaluator: string
	public reference: string
	public address: string
	public region: {
		id: number;
		name: string;
	}
	public serviceType: {
	  id: number;
	  name: string;
	}
	public problems: Array<{
	  idMongo: string;
	  name: string;
	  media_url: string;
	}>
}
